import { Dialog } from '@heidi/design-system/dialog';
import dynamic from 'next/dynamic';

export type ForceUpdateModalProps = {
  title: string;
  message: string;
  isInstalling?: boolean;
  actionText?: string;
  onUpdateNow: () => void;
  open?: boolean;
};

const ForceUpdateModalContent = dynamic(
  () =>
    import('./force-update-modal-content').then(
      (module) => module.ForceUpdateModalContent
    ),
  {
    ssr: false,
  }
);

const ForceUpdateModal = ({ open = true, ...props }: ForceUpdateModalProps) => {
  if (!open) return null;

  // The dialog stays open for as long as it is mounted (FORCED state), so the
  // content must not wait on an open-transition callback — `open` never
  // transitions, and useOpenChangeComplete only fires on changes, not on mount.
  return (
    <Dialog open={open}>
      <ForceUpdateModalContent {...props} />
    </Dialog>
  );
};

export default ForceUpdateModal;
